var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomemaplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.732 5.06821L17.7928 15.1927C18.4375 16.4825 17.4999 18 16.0583 18H12.732M12.732 5.06821L11.2345 2.07228C10.5198 0.642574 8.48017 0.642575 7.76553 2.07228L1.20723 15.1927C0.562541 16.4825 1.50013 18 2.9417 18H6.268M12.732 5.06821L9.5 8.30116M6.268 18H12.732M6.268 18L3.03601 14.7671M12.732 18L6.268 11.5341M9.5 8.30116L17.7416 16.5452M9.5 8.30116L6.268 11.5341M1.25841 16.5452L3.03601 14.7671M3.03601 14.7671L6.268 11.5341",
    stroke: "url(#paint0_linear_1_67)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_67",
    x1: 1,
    y1: 18,
    x2: 18,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F09C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomemaplogo);
export default __webpack_public_path__ + "static/media/homemaplogo.522899c576035439d3568a9497bcc01b.svg";
export { ForwardRef as ReactComponent };